import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { articlePicker_helper } from "../../modules/articlePicker_helper";
import { articlePicker_template } from "./articlePicker_template";
import { imageWidget_template } from "./imageWidget_template";
import { tagPicker_template } from "./tagPicker_template";

declare let ko: any;

export default class sensai_chat_template extends vnTemplate {

    public imagePickerHelper: imagePickerHelper;
    public imagePicker: imagePicker_template;
    public imageWidgetForDefaultBrandTagImage: imageWidget_template;
    public articlePicker: articlePicker_template;
    public articlePickerHelper: articlePicker_helper;
    public tagPicker: tagPicker_template;


    protected buildViewModel() {
        let self = this;

        return {
            
        };
    }

    protected initPartial() {

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(this.imagePicker, this.caller.viewModel, this.caller.getVnAppZone(), this.caller);

        this.imagePicker.setMode("single-select");
        this.imagePicker.setCaller(this.imagePickerHelper);

        this.articlePicker = new articlePicker_template("articlePicker", this.getTemplateViewModel(), this.caller);
        this.articlePickerHelper = new articlePicker_helper(this.articlePicker, this.caller.getVnAppZone(), this.caller);
        this.articlePicker.setIsHyperLinkModeEnabled(true);
        this.articlePicker.setCaller(this.articlePickerHelper);

        this.tagPicker = new tagPicker_template("tagPicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker.setIsSingle(true);
        this.tagPicker.setParent(this);
    }

    protected getTemplateName(): string {
        return "sensAI_vault_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large", "form-create-tag"];
    }

    public getTemplateHtml(): string {
        return /*html*/ `
            <style>
              .hidden {
                    display: none;
                }
            </style>
            <div class="form-body sensai-vault-form-body" id="sensAI_vault"> 
                <h2 class="sensai-title">
                    <span class="sens">Sens</span><span class="ai">AI</span>
                </h2>
                
                <div class="form-group seo-description sensai-vault-form-body" style="color: black">
                   
                    <div class="history" id="history" data-bind="foreach: chatHistory">
                        <!-- ko if: ($data.role === 'user') -->
                            <div data-bind="text: $data.content, class: $data.role"></div> 
                        <!-- /ko -->
                        <!-- ko if: ($data.role === 'system') -->
                            <div data-bind="html: $data.content, class: $data.role"></div>
                        <!-- /ko -->
                    </div>
                    <h3 class="history-title-above">How can I support you?</h3>
                    <div class="sensai-vault-user-query-container" style="margin-top: 2rem;" id="user-query-container" style="display: grid;">
                        <div class="sensai-vault-user-query-wrapper">
                            <div class="sensai-vault-user-query">
                                <textarea oninput='this.style.height = ""; this.style.height = this.scrollHeight + 3 + "px"' placeholder="Enter your prompt for SensAI" rows="3" data-bind="disable: isChatDisabled, value: userQuery, event: { keydown: onEnterKey }"></textarea>
                            </div>
                            <div class="sensai-vault-user-query-chat-container">
                                <div class="quick-prompts">
                                    <button tooltip="Find me internal link suggestions I can include in my article." class="btn quick-prompt quick-prompt-1" data-bind="event: { click: onClickQuickPrompt.bind($data, $element.getAttribute('tooltip')) }"><span class="icon i-link"></span></button>
                                    <button tooltip="Find me articles related to the content of my article." class="btn quick-prompt quick-prompt-2" data-bind="event: { click: onClickQuickPrompt.bind($data, $element.getAttribute('tooltip')) }"><span class="icon i-playlist"></span></button>
                                    <button tooltip="Find me images related to the content of my article." class="btn quick-prompt quick-prompt-3" data-bind="event: { click: onClickQuickPrompt.bind($data, $element.getAttribute('tooltip')) }"><span class="icon i-image"></span></button>
                                    <button tooltip="Find me tags related to the content of my article." class="btn quick-prompt quick-prompt-4" data-bind="event: { click: onClickQuickPrompt.bind($data, $element.getAttribute('tooltip')) }"><span class="icon i-tag"></span></button>
                                </div>
                                <div class="actions-btn-container">
                                    <div class="sensai-vault-clear-chat-container">
                                        <button tooltip="Clear chat history" class="btn clear-chat-btn" type="button" data-bind="disable: isChatDisabled, event: {click: onClickClearChatHistory}"><span class="icon i-delete"></span></button>
                                    </div>
                                    <div class="sensai-vault-submit-container">
                                        <button tooltip="Submit your prompt" class="chat-send-btn" type="button" data-bind="disable: isChatDisabled, event: {click: onClickSimilarArticles}">
                                        <!--<span class="icon i-send"></span>-->
                                            <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 449 448">
                                                <defs><style>.st0{fill:#fff;}</style></defs>
                                                <path class="st0" d="M441,2.8c5.2,3.8,7.8,9.8,6.8,16l-64,384c-.8,4.8-3.8,8.8-8,11.2-2.2,1.2-5,2-7.8,2s-4-.5-6-1.2l-113.2-46.2-60.5,73.8c-3,3.8-7.5,5.8-12.2,5.8s-3.8-.2-5.5-1c-6.2-2.2-10.5-8.2-10.5-15v-87.2L376,80,108.8,311.2l-98.8-40.5c-5.8-2.2-9.5-7.5-10-13.8-.2-6,2.8-11.8,8-14.8L424,2.2c2.5-1.5,5.2-2.2,8-2.2s6.5,1,9,2.8Z"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>     
                        </div>
                    </div>
                </div>
                <div id="generatedContent" data-bind="html: sensaiArticles" ></div>                
            </div>
        `;
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/sensai_chat_template.ts